import { useSearchParams } from "react-router-dom";

import { FORCE_LOGIN_QUERY_PARAM, FORCE_LOGIN_QUERY_VALUE } from "@ryde/shared";

/**
 * Whether the OAuth consent screen sent the user here demanding a fresh credential entry
 * (RYDE-7833). Read in one place so every IdP entry path — the buttons and the SAML email step —
 * forwards the same answer.
 */
export const useForceLoginParam = (): boolean => {
  const [searchParams] = useSearchParams();

  return searchParams.get(FORCE_LOGIN_QUERY_PARAM) === FORCE_LOGIN_QUERY_VALUE;
};
